import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class SmsStartBatchService {

  private path = '/sms-start-batch-password';

  constructor(private backendService: BackendService) { }



  saveSmsPassword(smsstartbatch: any) {
    return this.backendService.post(this.path + '/', smsstartbatch);

  }


  searchSmsPassword(currPage: number, pageSize: number, filter: any) {

    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);

  }

  deleteSmsPassword(id) {

    return this.backendService.post(this.path + '/delete/' + id, {});
  }
  getSmsPasswordById(id) {
    return this.backendService.get(this.path + '/slot/' + id);
  }


}
